import {
  BaseAuthedPage,
  MaxWidth,
  ModelFilters,
  ModelIndexActionCreateModal,
  ModelIndexSimple,
  ModelIndexTable,
  ModelPager,
  ModelSearch
} from '@rhino-project/ui-heroui';
import { useParams } from '@tanstack/react-router';

const SeasonPlayersPage = () => {
  const { team_season_id } = useParams({ strict: false });

  return (
    <BaseAuthedPage>
      <MaxWidth>
        <ModelIndexSimple
          analyticsSurface="season_players"
          model="player"
          syncUrl
          defaultFilter={{
            rosters: {
              team_season_id,
              roster_status: { status_type: 'active' }
            }
          }}
        >
          <div className="flex flex-col gap-3">
            <ModelSearch />
            <ModelFilters
              paths={[
                'player_positions.position::tree_subtree',
                'dob_year',
                'grad_year',
                'rosters.team_season.season',
                'rosters.team_season.team',
                'rosters.roster_status'
              ]}
            />
            <div className="flex flex-row">
              <div className="ml-auto">
                <ModelPager />
              </div>
            </div>
            <hr />
            <ModelIndexActionCreateModal />
            <ModelIndexTable
              paths={[
                'last_name',
                'first_name',
                'dob_year',
                'grad_year',
                'number',
                'positions'
              ]}
            />
          </div>
        </ModelIndexSimple>
      </MaxWidth>
    </BaseAuthedPage>
  );
};

export default SeasonPlayersPage;
